import AuditLogDebugDataPanel from './AuditLogDebugDataPanel';

export default function buildExpansionProps({ showDebugData, expandedRowId, formattedEntryByRowId }) {
  if (!showDebugData) return {};

  return {
    expandableRows: true,
    // The library's own expander icon carries no row-context accessible name, so a screen reader
    // cannot say which row it opens.
    expandableRowsHideExpander: true,
    expandableRowExpanded: row => row.id === expandedRowId,
    expandableRowsComponent: AuditLogDebugDataPanel,
    expandableRowsComponentProps: { formattedEntryByRowId },
  };
}
